'use client';
import Field from '@/components/ui/Field';
import Form from '@/components/ui/Form';
import SubmitButton from '@/components/ui/SubmitButton';
import { PublishType } from '@prisma/client';
import { Label } from '@radix-ui/react-context-menu';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/Select';
import { addLead } from './actions';
import { Input } from '@/components/ui/Input';
import { Switch } from '@/components/ui/Switch';
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import config from '@/config';

export default function AnalyzeLeadForm() {
  const [hasHelpCenter, setHasHelpCenter] = useState(true);
  return (
    <Form action={addLead} className="stack">
      <Field name="companyName" label="Company name">
        <Input placeholder="Pied Piper" />
      </Field>

      <div className="h-4" />

      <Field name="website" label="Website URL">
        <Input placeholder="https://piedpiper.com" />
      </Field>

      <div className="h-4" />
      <Label className="row justify-between">
        <div className="text-sm font-medium text-contrast-600">
          Do you have a help center / knowledge base?
        </div>
        <Switch checked={hasHelpCenter} onCheckedChange={setHasHelpCenter} />
      </Label>

      <div className="h-4" />
      <AnimatePresence>
        {hasHelpCenter && (
          <motion.div
            animate={{ height: 'auto', opacity: 1 }}
            initial={{ height: 0, opacity: 0 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden p-2 -m-2"
          >
            <div className="flex-none stack-4">
              <Field name="helpCenter" label="What's the URL?">
                <Input placeholder="https://help.piedpiper.com" />
              </Field>
              <Field name="helpCenterType" label="Where is it hosted?">
                <Select defaultValue={PublishType.ZENDESK}>
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {Object.entries(config.publishing.displayNames).map(
                      ([type, displayName]) => (
                        <SelectItem key={type} value={type}>
                          {type === PublishType.WEBSITE
                            ? 'Custom / Self Hosted'
                            : displayName}
                        </SelectItem>
                      )
                    )}
                  </SelectContent>
                </Select>
              </Field>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="h-4" />

      <Field name="name" label="Your name">
        <Input placeholder="Richard Hendricks" />
      </Field>

      <div className="h-4" />

      <Field name="email" label="Your email (so we can send you the report)">
        <Input type="email" placeholder="richard@piedpiper.com" />
      </Field>

      <div className="h-8" />

      <SubmitButton size="lg">Analyze</SubmitButton>
    </Form>
  );
}
